import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["colorSet", "placement", "className", "id", "trigger", "label", "description", "aria-label", "withPortal"];
import React, { useState } from 'react';
import { TooltipTrigger } from "../TooltipTrigger/index.mjs";
import { TooltipWrapper } from "./index.mjs";
export var StatefulTooltip = /*#__PURE__*/React.forwardRef(function StatefulTooltip(_ref, ref) {
  var colorSet = _ref.colorSet,
    placement = _ref.placement,
    className = _ref.className,
    id = _ref.id,
    trigger = _ref.trigger,
    label = _ref.label,
    description = _ref.description,
    ariaLabel = _ref['aria-label'],
    withPortal = _ref.withPortal,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showTooltip = _useState2[0],
    setShowTooltip = _useState2[1];
  var triggerWithAttrs = {};
  if (label) {
    triggerWithAttrs['aria-labelledby'] = id;
  }
  if (description) {
    triggerWithAttrs['aria-label'] = ariaLabel;
    triggerWithAttrs['aria-describedby'] = id;
  }
  return /*#__PURE__*/React.createElement(TooltipTrigger, {
    overlay: showTooltip && /*#__PURE__*/React.createElement(TooltipWrapper, Object.assign({
      ref: ref,
      id: id
    }, props), label || description),
    onShow: function onShow() {
      return setShowTooltip(true);
    },
    onHide: function onHide() {
      return setShowTooltip(false);
    },
    placement: placement,
    withPortal: withPortal
  }, trigger(triggerWithAttrs));
});